import React, { FC } from 'react';

import { BlurIcon } from '../icons/blur';
import { Spinner, Pressable } from '../../shared/ui';

type LobbyBlurToggleProps = {
  isBlurEnabled: boolean;
  toggleBlur: () => void;
  isSupported: boolean;
  isPreparing: boolean;
  disabled?: boolean;
};

/** Переключатель размытия фона в лобби. На браузерах без поддержки не рендерится. */
export const LobbyBlurToggle: FC<LobbyBlurToggleProps> = ({
  isBlurEnabled,
  toggleBlur,
  isSupported,
  isPreparing,
  disabled,
}) => {
  if (!isSupported) return null;

  return (
    <Pressable
      onClick={toggleBlur}
      disabled={disabled || isPreparing}
      aria-pressed={isBlurEnabled}
      aria-label={isBlurEnabled ? 'Выключить размытие фона' : 'Размыть фон'}
      title={isBlurEnabled ? 'Выключить размытие фона' : 'Размыть фон'}
      className="relative rounded-full disabled:opacity-40"
    >
      <BlurIcon checked={isBlurEnabled} width={36} height={36} />
      {isPreparing && (
        <span className="absolute inset-0 flex items-center justify-center">
          <Spinner size="sm" className="text-white" />
        </span>
      )}
    </Pressable>
  );
};
